export const CHECKOUT_URL = 'https://smart-home-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offerta'

export const PRODUCT_NAME = 'SMART HOME PRO™'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/geiXsF32MBk8JfwJ8CutmY/ChatGPT-Image-14-ago-2026_-06_19_25-p.m..webp'

export const PRODUCT_ALT = 'SMART HOME PRO™ — cofanetto del sistema completo 6-in-1 per la domotica'

export const PRICE_FULL = '€97'

export const PRICE_TODAY = '€27'
